import React from "react";
import { Header, LoadingScreen } from "../..";
import { LayoutContainer, Page } from "../../layouts/Layout";
import { CentreCol } from "../Layout";
export var FutureListPage = function (_a) {
    var children = _a.children, title = _a.title, navigation = _a.navigation, reference = _a.reference, extra = _a.extra, back = _a.back, loading = _a.loading, _b = _a.type, type = _b === void 0 ? "table" : _b, subtitle = _a.subtitle;
    if (loading) {
        return React.createElement(LoadingScreen, null);
    }
    return (React.createElement(Page, null,
        React.createElement(Header, { title: title, navigation: navigation, reference: reference, extra: extra, back: back, usage: "portal", subtitle: subtitle }),
        React.createElement(LayoutContainer, null,
            React.createElement(CentreCol, null,
                React.createElement("div", { className: type === "grid" ? "grid grid--tiled" : "layout--table" }, children)))));
};
